// Wrapper around shared @lingoshade/api factory for web client
// NOTE: Keep token extraction logic aligned with existing axios-based apiClient until full migration.
// Import from source to ensure latest typings (avoids temporary any casts)
import { createApiClient } from "../../../packages/api/src";

const baseUrl =
  import.meta.env.MODE === "production"
    ? "/api"
    : `${(import.meta.env.VITE_API_URL ?? "").replace(/\/+$/u, "")}/api`;

// Enable debug logging in development
if (import.meta.env.DEV || import.meta.env.MODE === "development") {
  (globalThis as Record<string, unknown>).__DEV__ = true;
}

// Fully typed shared API client
export const sharedApi = createApiClient({ baseUrl });

export function getApiRequestUrl(path: string): string {
  return new URL(`${baseUrl}${path}`, window.location.origin).toString();
}

// Explicit re-export of factory type for downstream usage (helps IDE refresh)
export type SharedApiClient = ReturnType<typeof createApiClient>;

// Helper to get bearer token from localStorage (same key as axios client)
export function getAuthToken(): string | null {
  return localStorage.getItem("token");
}

export type SharedApi = typeof sharedApi;
